import React, { useEffect, useState } from "react"
import ReactModal from "react-modal"
import Modal from "react-modal"

type ProfileModalProps = {
  isOpen: boolean
  onRequestClose: () => void
  onUpdateUserPic: (userPicture: string) => Promise<void>
  onUpdateUserName: (firstName: string, lastName: string) => Promise<void>
  userProfile: Record<string, any>
}

export const ProfileModal: React.FC<ProfileModalProps> = ({
  isOpen,
  onRequestClose,
  onUpdateUserPic,
  onUpdateUserName,
  userProfile,
}) => {
  const [firstName, setFirstName] = useState(userProfile?.firstName || "")
  const [lastName, setLastName] = useState(userProfile?.lastName || "")
  const [userPicture, setUserPicture] = useState(userProfile?.picture || "")
  const [isSubmitting, setIsSubmitting] = useState(false)

  useEffect(() => {
    setFirstName(userProfile?.firstName || "")
    setLastName(userProfile?.lastName || "")
    setUserPicture(userProfile?.picture || "")
  }, [userProfile])

  const handleUpdateProfile = async () => {
    setIsSubmitting(true)
    if (userPicture) {
      await onUpdateUserPic(userPicture)
    }
    if (firstName || lastName) {
      await onUpdateUserName(firstName, lastName)
    }
    setIsSubmitting(false)
    onRequestClose()
  }

  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      style={{
        content: {
          top: "50%",
          left: "50%",
          transform: "translate(-50%,-50%)",
          padding: 10,
          zIndex: 10,
          borderRadius: 14,
          bottom: "auto",
          width: 500,
        },
        overlay: {
          zIndex: 10,
          background: "rgba(0,0,0,0.1)",
        },
      }}
    >
      <h2>Update Profile</h2>
      <div className="profile-modal-field">
        <label>First Name</label>
        <input
          type="text"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
        />
      </div>
      <div className="profile-modal-field">
        <label>Last Name</label>
        <input
          type="text"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
        />
      </div>
      <div className="profile-modal-field">
        <label>Profile Picture</label>
        <input
          type="file"
          accept="image/*"
          onChange={(e) => {
            if (e.target.files && e.target.files[0]) {
              const file = e.target.files[0]
              const reader = new FileReader()
              reader.onload = () => {
                if (reader.result) {
                  const img = new Image()
                  img.onload = () => {
                    const canvas = document.createElement("canvas")
                    const ctx = canvas.getContext("2d")
                    if (ctx) {
                      canvas.width = 128
                      canvas.height = 128
                      ctx.drawImage(img, 0, 0, 128, 128)
                      const scaledImage = canvas.toDataURL("image/png")
                      console.log(scaledImage)
                      setUserPicture(scaledImage)
                    }
                  }
                  img.src = reader.result as string
                }
              }
              reader.readAsDataURL(file)
            }
          }}
        />
      </div>
      {userPicture && (
        <div className="profile-modal-preview">
          <img
            src={userPicture}
            alt="Profile Preview"
            style={{ width: "100px", height: "100px", borderRadius: "50%" }}
          />
        </div>
      )}
      <div className="profile-modal-actions">
        <button onClick={onRequestClose} disabled={isSubmitting}>
          Cancel
        </button>
        <button onClick={handleUpdateProfile} disabled={isSubmitting}>
          Save
        </button>
      </div>
    </ReactModal>
  )
}
